import axios from "axios";
import BASE_URL from "../config/apiConfig"
import GroupAllUsers from "../components/FieldTags/GroupAllUsers";
import GroupDCT from "../components/FieldTags/GroupDCT";
import GroupBiorepositoryOps from "../components/FieldTags/GroupBiorepositoryOps";
import GroupBDRBiologists from "../components/FieldTags/GroupBDRBiologists";
import GroupApprovers from "../components/FieldTags/GroupApprovers";
import ROLES from "./roles";

export const getFileExtension = (file) => {
    const i = file.name.lastIndexOf(".");
    return i === -1 ? null : file.name.slice(i + 1);
}

export const formatValue = (value) => {
    let newValue = value;
    newValue = Array.isArray(newValue) ? newValue.join() : newValue;
    if (typeof newValue === "string" && newValue.charAt(0) === ",") {
        newValue = newValue.substring(1);
    }
    return newValue;
}

export const handleFileUpload = async (folderId, fileName, fileId, file) => {
    if (file) {
        try {
            const formData = new FormData();
            formData.append("file", file);

            if (fileId && fileId !== "") {
                return await axios.post(BASE_URL + `/api/box/upload/${fileId}`, formData, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                    params: {
                        fileName: fileName + getFileExtension(file),
                    },
                    withCredentials: true,
                });
            } else {
                return await axios.post(BASE_URL + "/api/box/upload", formData, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                    params: {
                        folderId: folderId,
                        fileName: fileName + getFileExtension(file),
                    },
                    withCredentials: true,
                });
            }
        } catch (error) {
            console.error("Error uploading file:", error);
        }
    }
};

export const getFileVersions = async (fileId) => {
    try {
        const response = await axios.get(BASE_URL + `/api/box/files/versions/${fileId}`, { withCredentials : true });
        return response.data.total_count + 1;
    } catch (error) {
        console.error("Failed to download file:", error);
    }
}

export const formatDateTime = (inputDateTime) => {
    if (inputDateTime) {
        const date = new Date(inputDateTime.slice(0, 16).replace("T", " "))
        const dateOptions = { year: "numeric", month: "2-digit", day: "2-digit" };
        const timeOptions = { hour: "2-digit", minute: "2-digit", hour12: true };

        const formattedDate = date.toLocaleDateString("en-US", dateOptions);
        const formattedTime = date.toLocaleTimeString("en-US", timeOptions);

        return `${formattedDate} ${formattedTime}`;
    } else {
        return "";
    }
}

export const formatDate = (inputDate) => {
    if (inputDate) {
        const [year, month, day] = inputDate.split('-');
        return `${month}/${day}/${year}`;
    } else {
        return "";
    }
}

export const renderGroupComponent = (tag) => {
    switch (tag) {
        case ROLES.BIOLOGIST:
            return <GroupBDRBiologists />;
        case ROLES.APPROVER:
            return <GroupApprovers />;
        case ROLES.BIOOPS:
            return <GroupBiorepositoryOps />;
        case ROLES.DCT:
            return <GroupDCT />;
        case ROLES.DEFAULT:
            return <GroupAllUsers />;
        default:
            return <GroupAllUsers />;
    }
};

/**
 * Checks if the current user has at least one of the allowed roles.
 * Admins always pass.
 * @param user - User object to check role
 * @param {number[]} allowedRoleIds - Array of role IDs to check
 * @returns {boolean}
 */
export const checkRole = (user, allowedRoleIds = []) => {
    return user.selectedRoleId === ROLES.ADMIN || allowedRoleIds.includes(user.selectedRoleId);
};

export const hasNonEmptyFiles = (files) => {
    return files.some((file) => file);
}

export const isDataChanged = (currData, origData) => {
    const ignoreElements = [
        "id",
        "epId",
        "versionId",
        "version",
        "createdBy",
        "createdAt",
        "updatedBy",
        "updatedAt",
    ];

    for (const key in currData) {
        if (ignoreElements.includes(key)) {
            continue;
        }
        if ((currData[key] || origData[key]) && currData[key] !== origData[key]) {
            return true;
        }
    }
    return false;
};

export const isValidDate = (dateString) => {
    if (!dateString) {
        return false;
    }
    const dateObject = new Date(dateString);
    return !isNaN(dateObject.getTime());
}

export const generateDownload = (response) => {
    const disposition = response.headers["content-disposition"];
    const fileNameRegex = /filename[^=]*=((['"]).*?\2|[^;\n]*)/;
    const matches = fileNameRegex.exec(disposition);
    let matchedName;
    if (matches != null && matches[1]) {
        matchedName = matches[1].replace(/['"]/g, "");
    }

    const blobUrl = window.URL.createObjectURL(new Blob([response.data]));
    const tempLink = document.createElement("a");
    tempLink.href = blobUrl;
    tempLink.setAttribute("download", matchedName);
    tempLink.click();
    window.URL.revokeObjectURL(blobUrl);
}
